<template>
    <v-form @submit.prevent="addAdminUser" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold">Add Linked Account Admin User</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="form-container">
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <v-alert :value="true" color="info" icon="info" outline class="header-intro">
                            By adding a linked account user, you grant them admin rights, enabling them to manage the linked company account.
                        </v-alert> 
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <v-autocomplete
                            v-model="selectedUserId"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            color="blue-grey lighten-2"
                            label="Request for Employee"
                            item-text="name"
                            item-value="userId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :disabled="disabled" :loading="loading" dark style="margin-right:25px;">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import commonData from '@/common/data'
import employeeApi from '@/api/employees'
import companyApi from '@/api/company'
import awsS3Helper from '@/helpers/aws-s3'
import pageKeys from '@/common/pagekeys'

export default {
    data () {
        return {
            common_data: null,
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            loading_employees: false,
            rules: {
                required: value => !!value || 'Required field.',
            },       
            employees: [],
            existing_users: [],
            selectedUserId: null
        }
    },
    methods: {
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAllByPageKey(pageKeys.company_linked_account)
                if (response && response.status == 200) {
                    //exclude those already exist
                    const filtered = response.data.employees.filter(user => {
                        return !this.existing_users.some(x => x.parentUserId == user.userId) 
                    });
                    filtered.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                            firstName: item.firstName,
                            lastName: item.lastName,
                            email: item.email,
                            group: item.team
                        })
                    })
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async addAdminUser() {
            try {
                this.loading = true
                if (this.$refs.form.validate()) {
                    const selectedUser = this.employees.filter(x => x.userId == this.selectedUserId)[0]
                    var data = {
                        LinkCompanyId: this.linkCompanyId,
                        parentUserId: selectedUser.userId,
                        firstName: selectedUser.firstName,
                        lastName: selectedUser.lastName,
                        position: 'SweldoNow Admin',
                        email: selectedUser.email
                    }
                    const response = await companyApi.addLinkedAccountUser(data)
                    if (response.status == 200) {
                        this.$emit('send', response.data)
                        this.closeDialog()
                    }
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setData(data) {
            this.selectedUserId = null
            this.existing_users = data
            await this.getEmployees()
        },
        closeDialog() {
            this.$emit('update:dialogAddLinkAccountUser', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
    computed: {
        isMobile() {
            return window.innerWidth < 800
        },
        linkCompanyId() {
            if (this.existing_users.length) {
                return this.existing_users[0].linkCompanyId
            }
        }
    },
    created() {
        this.common_data = commonData
    }
}
</script>
<style scoped>
.form-container {
    padding:10px 20px 0px 20px;
}
.form-row {
    padding: 5px 15px 5px 15px;
}
</style>